(function () {
    'use strict';

    function VideoCallSettingComponentController($scope, $state, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader) {
        //
        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.videoPlatformChanged = videoPlatformChanged;

        loadAll();
        loadPage();

        function loadAll() {
        }

        function loadPage(page) {
            translatePartialLoader.addPart('videoCallSettingInfo');
            translatePartialLoader.addPart('videoPlatformType');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();

            if (!$ctrl.mode) {
                $ctrl.mode = 'COMPANY_SETTING';
            }

        }

        function videoPlatformChanged() {

        }

    }

    var VideoCallSettingComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/video-call-setting/partial-form.video-call-setting.html',
        controller: VideoCallSettingComponentController,
        bindings:
            {
                videoCallSettingInfo: '=',
                mode: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('pfVideoCallSetting', VideoCallSettingComponent)

    VideoCallSettingComponentController.$inject = ['$scope', '$state', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader'];


})();

